import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import type { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'app-brand-name-logo-renderer',
  imports: [CommonModule],
  standalone: true,
  templateUrl: './brand-name-logo-renderer.component.html',
  styleUrl: './brand-name-logo-renderer.component.scss'
})
export class BrandNameLogoRendererComponent implements ICellRendererAngularComp {
  public name!: string;
  public logoPath!: string;
  public customClass: string = '';
  private readonly defaultImagePath = 'images/no-logo.png';

  agInit(params: ICellRendererParams): void {
    this.loadComponent(params);
  }

  refresh(params: ICellRendererParams): boolean {
    this.loadComponent(params);
    return true;
  }

  private loadComponent(params: ICellRendererParams) {
    this.name = params.value.name;
    this.logoPath = params.value.logoPath || this.defaultImagePath;
    this.customClass = (params as any).customClass || '';
  }

  onImageError(event: Event): void {
    const img = event.target as HTMLImageElement;
    if (img.src !== this.defaultImagePath) {
      img.src = this.defaultImagePath;
    }
  }
}